<template>
    <div>
        <!--顶部日期搜索-->
        <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="3">
                <el-date-picker
                        v-model="queryInfo.date"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        @change="changeData">
                </el-date-picker>
            </el-col>
            <el-col :span="2" :offset="19">
                <el-button v-permission="['BUSINESS-USER-PROJECT-FOCUS']" type="primary" icon="el-icon-setting" @click="showSetDialog">设置</el-button>
            </el-col>
        </el-row>
        <echarts :chartHeight="objstyle" :chartData="echartsData" :isAxisChart="true"></echarts>
        <div v-if="infoDialogVisible">
            <el-dialog title="关注字段" :visible.sync="infoDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="70%"
                       @close="handleCloseInfo">
                <SetField :deviceInfo="deviceInfo" :isChart="isChart" @updateCol="update"></SetField>
            </el-dialog>
        </div>
    </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import {dataLast, deviceChart, deviceInfo} from '@/api/device'
import Echarts from '@/components/Echarts'
import {timeFormat} from '@/utils/common'
import SetField from '@/components/focusFields/index'
export default {
    name: '',
    components: {
        Echarts,SetField
    },
    data(){
      return {
          echartsData:{
              chartlist:[],
              dimensions: [],
              cnObj: {}
          },
          queryInfo: {
              date: ''
          },
          pickerOptions: {
              disabledDate(time) {
                  return time.getTime() > Date.now();
              },
              shortcuts: [
                  {
                      text: '今天',
                      onClick(picker) {
                          picker.$emit('pick', new Date());
                      }
                  }, {
                      text: '昨天',
                      onClick(picker) {
                          const date = new Date();
                          date.setTime(date.getTime() - 3600 * 1000 * 24);
                          picker.$emit('pick', date);
                      }
                  }, {
                      text: '一周前',
                      onClick(picker) {
                          const date = new Date();
                          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                          picker.$emit('pick', date);
                      }
                  }]
          },
          objstyle: 0,
          infoDialogVisible: false,
          isChart: false,
          timer:null,
          deviceInfo:{}
      }
    },
    methods: {
        init(){
            this.queryInfo.date = timeFormat(new Date())
            this.getHeight()

            this.getChartData()
            // this.echartsData.dimensions= this.deviceInfo.chartStruct.split(',')
        },
        getHeight() {
            this.objstyle = window.innerHeight - 60 -40 -40 -20
        },
        getChartData(){
            let param = {}
            param.date = this.queryInfo.date
            deviceChart(param,this.deviceInfo.id).then(response => {
                // console.log('项目曲线列表',response.data)
                if(response.code!=200){
                    this.getHeight()
                    return this.$message.error('获取曲线数据失败！')
                }
                this.echartsData.cnObj=this.deviceInfo.pair
                if(this.deviceInfo.chartStruct===undefined){
                    this.deviceInfo.chartStruct = this.deviceInfo.projectStruct
                }
                this.echartsData.dimensions = this.deviceInfo.chartStruct.trim().split(',')
                this.echartsData.chartlist = response.data
                if(this.echartsData.chartlist.length>0&&this.echartsData.chartlist[0].DNT.substring(0,10)===timeFormat(new Date())){
                    this.startTime()
                }else{
                    this.closeTime()
                }
            })
        },
        changeData(){
            this.getChartData()
        },
        showSetDialog(){
            this.infoDialogVisible = true
            this.isChart = true
        },
        handleCloseInfo() {
            this.infoDialogVisible = false
        },
        update(){
            this.handleCloseInfo()
            this.closeTime()
            this.getDeviceInfo()
            /*this.init()
            this.getChartData()*/
        },
        startTime(){
            let that=this
            this.timer = setInterval(()=>{
                dataLast(that.deviceInfo.id,{type:'chart'}).then(response => {
                    if(response.code!=200){
                        console.log('获取曲线最新数据失败！')
                    }else{
                        if(response.data.DNT!=that.echartsData.chartlist[0].DNT){
                            that.echartsData.chartlist.push(response.data)
                            //console.log('添加最新数据')
                        }
                    }
                })
            },60*1000)
        },
        closeTime(){
            if (this.timer) {
                clearInterval(this.timer); //关闭
                console.log('销毁定时器')
            }
        },
        getDeviceInfo(){
            let pid=Number(this.$route.query.pid)
            deviceInfo({pid:pid}).then(response => {
                if(response.code!=200){
                    this.$message.error(response.msg)
                }else{
                    this.deviceInfo = response.data
                    // console.log(this.deviceInfo)
                    this.init()
                    window.addEventListener('resize', this.getHeight)
                }
            })
        }
    },
    computed: {
        /*...mapGetters([
            'deviceInfo'
        ])*/
    },
    created(){
        this.getHeight()
        this.getDeviceInfo()
        // console.log(this.$router)
        // console.log(this.$route)
    },
    beforeDestroy() {
        this.closeTime()
    }
}
</script>

<style scoped>

</style>
